import React from 'react';
import { Box, Button } from '@mui/material';
import { colors, font, layout } from '../theme/tokens';
import { LANGUAGES, useI18n } from '../i18n';

/**
 * Compact DE | EN | FR segmented control. Small enough for the topbar and
 * still a comfortable tap target on a tablet.
 */
const LanguageSelector: React.FC<{ onDark?: boolean }> = ({ onDark = false }) => {
  const { lang, setLang, t } = useI18n();

  const border = onDark ? colors.onDarkBorder : colors.borderStrong;
  const idle = onDark ? colors.onDarkMuted : colors.inkMuted;

  return (
    <Box
      role="group"
      aria-label={t('app.language')}
      sx={{
        display: 'flex',
        // Solid ground so the segments read against a tinted header bar.
        backgroundColor: onDark ? 'transparent' : colors.bg,
        border: `1px solid ${border}`,
        borderRadius: layout.radius,
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      {LANGUAGES.map((l, i) => {
        const active = l.code === lang;
        return (
          <Button
            key={l.code}
            onClick={() => setLang(l.code)}
            disableRipple
            aria-pressed={active}
            sx={{
              minWidth: 0,
              px: 1.25,
              py: 0.6,
              borderRadius: 0,
              borderLeft: i === 0 ? 'none' : `1px solid ${border}`,
              fontFamily: font.mono,
              fontSize: '11px',
              fontWeight: active ? 700 : 500,
              letterSpacing: '0.06em',
              textTransform: 'none',
              backgroundColor: active ? colors.blue : 'transparent',
              color: active ? colors.onDark : idle,
              '&:hover': {
                backgroundColor: active ? colors.blueDeep : (onDark ? 'rgba(255,255,255,0.06)' : colors.blueSoft),
                color: active ? colors.onDark : (onDark ? colors.onDark : colors.blue),
              },
            }}
          >
            {l.label}
          </Button>
        );
      })}
    </Box>
  );
};

export default LanguageSelector;
